var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    on: {
      "click": _vm.toggle
    }
  }, 'v-card', {
    color: _vm.color
  }, false), [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-list-item-avatar')], 1), _c('v-col', {
    staticClass: "pa-8"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.seeker.name) + " " + _vm._s(_vm.seeker.usernmae) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.seeker.gender) + " | " + _vm._s(_vm.seeker.age) + " | " + _vm._s(_vm.seeker.email) + " | " + _vm._s(_vm.seeker.phone) + " ")])], 1)], 1), _c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-list-item-action', [_c('v-checkbox', {
    attrs: {
      "value": _vm.isSelected,
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "ml-4"
        }, [_vm._v(" 선택하기 ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }